import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { GridContainer } from '@lusha-ui/core';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Star from './Star';
const stars = [1, 2, 3, 4, 5];
function RateStars(props) {
    const { onRateChange } = props;
    const [rate, setRate] = useState(null);
    const [hoverRate, setHoverRate] = useState(null);
    useEffect(() => {
        onRateChange(rate);
    }, [rate]);
    const rateCompareValue = hoverRate || rate;
    return (_jsx(GridContainer, { justifyContent: 'space-between', css: css `
        padding: 24px 28px 0;
      `, onMouseLeave: e => {
            setHoverRate(null);
        }, children: _.map(stars, star => (_jsx(Star, { value: star, active: !!rateCompareValue && rateCompareValue >= star, isLastActive: rateCompareValue === star, onSelect: setRate, onHover: setHoverRate }, `rate-star/${star}`))) }));
}
export default RateStars;
